<div role="tablist" [class]="tabsClasses">
  @for (tab of tabs; track tab) {
    <a
      role="tab"
      class="tab"
      [class.tab-active]="isActive(tab.id)"
      [class.tab-disabled]="tab.disabled"
      [attr.aria-selected]="isActive(tab.id)"
      [attr.tabindex]="tab.disabled ? -1 : 0"
      (click)="!tab.disabled && onTabClick(tab.id)"
      (keydown.enter)="!tab.disabled && onTabClick(tab.id)"
      (keydown.space)="!tab.disabled && onTabClick(tab.id)">
      {{ tab.label }}
    </a>
  }
</div>

<div class="mt-4">
  <ng-content></ng-content>
</div>


